<div class="mt-20">
    <form [formGroup]="enrollPatientTransmitterFormGroup">
        <input type="hidden" name="patientid" [ngModel]="patientid" formControlName="patientId" [id]="
                identifierService.dropdownId(
                    'enroll-patient-transmitter',
                    'patientId'
                )
            " />
        <ng-template matStepLabel data-tx-key="label.gb.transmitter">{{ labels['label.gb.transmitter'] }}
        </ng-template>
        <div class="row middle-xs">
            <div class="col-xs-2">
                <div [id]="identifierService.labelId('enrollPatTx', 'transmitterTitle')" class="pageTitle" data-tx-key="label.gb.transmitter">
                    {{ labels['label.gb.transmitter'] }}
                </div>
            </div>
            <div class="col-xs-3">
                @if (profileMode()) {
                <div>
                    @if (viewMode()) {
                    <button mat-raised-button color="primary" style="margin-right: 5px" (click)="setDisplayMode('edit')"
                        id="profileEditButton" [disabled]="!hasPatientDataEntryAccess" data-tx-key="label.gb.edit">
                        {{ labels['label.gb.edit'] }}
                    </button>
                    }
                    @if (editMode()) {
                      <button mat-raised-button class="mr-20" color="accent" (click)="cancelEditClick()"
                              id="profileCancelButton" data-tx-key="label.gb.button_cancel">
                        {{ labels['label.gb.button_cancel'] }}
                      </button>
                      <button mat-raised-button color="primary" class="mr-5" (click)="profileSaveClick()"
                        id="profileSaveButton" data-tx-key="label.gb.save">
                        {{ labels['label.gb.save'] }}
                      </button>
                    }
                </div>
                }
            </div>
            <div class="col-xs-7 end-xs">
                @if (profileMode()) {
                <div class="controls">
                    <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="printProfileLink"
                        (click)="openPrintDialog()" data-tx-key="label.gb.print_profile">
                        {{ labels['label.gb.print_profile'] }}
                    </div>
                    @if (viewMode()) {
                    <div class="figLink" style="margin-left: 10px; margin-top: 10px" [ngStyle]="{
                        'pointer-events': isSP2CanEnroll ? 'auto' : 'none',
                        color: isSP2CanEnroll ? '#03a9f4' : '#9e9e9e'
                    }" id="releasePatientLink" (click)="releasePatient()">
                        {{ labels['label.gb.release_patient'] }}
                    </div>
                    <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="moreActionsLink">
                        <a [id]="identifierService.buttonId('enrollPatientTransmitter', 'moreActions')" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">{{ labels['label.gb.more_actions']
                            }}
                            &#8942;</a>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item id="reactivatePatientButton" (click)="reActivatePatient()"
                [disabled]="!hasPatientDataEntryAccess" data-tx-key="label.gb.reactivate_pat">
                {{ labels['label.gb.reactivate_pat'] }}
            </button>
        </mat-menu>
        <br />
        @if (displayMode == 'view') {
        <div>
            @if (isPatientRelease) {
            <div class="yellow-card">
                <span [id]="identifierService.labelId('enrollPatTx', 'releasePatientMsg')" [innerHTML]="releasePatientMsg"></span>
            </div>
            }
        </div>
        }
        <mat-card appearance="outlined" class="flat mt-10">
            <div class="row">
                <div class="col-xs-6 equal-textbox">
                    <h3 class="merlin-header">
                        <span [id]="identifierService.labelId('enrollPatientTransmitter', 'transmissionHeading')">{{ getTransmissionHeadingDisplay() }}</span>
                    </h3>
                    <p class="blueStyle" [class]="showTextBox() ? 'mb-30':''">
                        @if (bluetoothCapable) {
                        <span [id]="identifierService.labelId('enrollPatTx', 'transmitterDetailsPrompt')" data-tx-key="msg.gb.transmitter_details_prompt">
                            {{ labels['msg.gb.transmitter_details_prompt'] }}
                        </span>
                        }
                        @if (!bluetoothCapable) {
                        <span [id]="identifierService.labelId('enrollPatTx', 'transmitterSetupPrompt')" [innerHTML]="
                                labels['msg.gb.transmitter_setup_prompt']
                                    | safe : 'html'
                            " data-tx-key="msg.gb.transmitter_setup_prompt"></span>
                        }
                    </p>
                    @if (!bluetoothCapable) {
                    <div class="row">
                      @if (showTextBox()) {
                        <div class="col-xs-6 gridActionPanel pt-10">
                            <merlin-textbox controlName="transmitterSerialNum" class="w-100" (change)="onTextboxChange($event)"
                                [maxLength]="enrollPatientTransmitter?.deviceType == 'LP'? 9 : 8" [groupName]="
                                            enrollPatientTransmitterFormGroup
                                        " label="{{
                                            labels['label.gb.trans_serial_no']
                                        }}" [required]="
                                            enrollPatientTransmitterFormGroup.get(
                                                'transmitterSerialNum'
                                            )?.invalid &&
                                            transmitterSerialRqdFlag
                                        " [id]="
                                            identifierService.dropdownId(
                                                'enroll-patient-transmitter',
                                                'transmitterSerialNum'
                                            )
                                        " data-tx-key="label.gb.trans_serial_no">
                            </merlin-textbox>
                             </div>
                            }
                      @if (showTextLabel()) {
                        <div class="col-xs-12 gridActionPanel">
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'txSerialNo')" style="font-weight: bold" data-tx-key="label.gb.trans_serial_no">{{
                                labels['label.gb.trans_serial_no']
                                }}: &nbsp;</span><span [id]="identifierService.labelId('enrollPatientTransmitter', 'profileSerial')">{{ profileSerial }}</span>
                        </div>
                      }
                    </div>
                    <div class="row">
                      @if (showTextBox()) {
                        <div class="col-xs-6 gridActionPanel">
                            <mat-form-field class="merlin-select merlin-row-styl w-100" appearance="outline"
                                floatLabel="auto">
                                <mat-label [id]="identifierService.labelId('enrollPatTx', 'transmitterModel')" data-tx-key="label.gb.tranmsitter_model">
                                    <!-- @if (
                                    enrollPatientTransmitterFormGroup.get(
                                    'transmitterModelNum'
                                    )?.invalid
                                    ) {
                                    <span style="
                                                    color: red;
                                                    position: relative;
                                                ">* </span>
                                    } -->
                                    {{
                                    labels['label.gb.tranmsitter_model']
                                    }}</mat-label>
                                <mat-select disableOptionCentering formControlName="transmitterModelNum" label="{{
                                                labels['label.gb.tranmsitter_model']
                                            }}" (selectionChange)="
                                                onDropDownChange($event)
                                            " disableOptionCentering [id]="
                                                identifierService.dropdownId(
                                                    'enroll-patient-transmitter',
                                                    'transmitterModelNum'
                                                )
                                            " data-tx-key="label.gb.tranmsitter_model">
                                    <mat-option [value]="null">&nbsp;</mat-option>
                                    @for (
                                    eachObj of enrollPatientTransmitter
                                    ?.dropdowns
                                    ?.transmitterModelNums
                                    ; track
                                    eachObj) {
                                    <mat-option [id]="identifierService.listitemId('enrollPatTx', 'transmitterModel_' + eachObj.value)" [value]="eachObj.value">
                                        {{ eachObj.label }}
                                    </mat-option>
                                    }
                                </mat-select> </mat-form-field><br />
                             </div>
                            }
                      @if (showTextLabel()) {
                      <div class="col-xs-12 gridActionPanel mb-10">
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'txModel')" style="font-weight: bold" data-tx-key="label.gb.tranmsitter_model">{{
                                labels['label.gb.tranmsitter_model']
                                }}: &nbsp;</span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'transmitterModelVal')">{{
                                getTransmitterModelNumLabel(
                                viewData.transmitterModelNum
                                )
                                }}</span>
                        </div>
                      }
                      </div>
                    }
                    @if (bluetoothCapable) {
                    <div class="row">
                        <div class="col-xs-10 col-lg-12 gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox controlName="transmitterModelNum" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.tranmsitter_model']
                                    }}" placeholder="{{
                                        labels['label.gb.tranmsitter_model']
                                    }}" [disabled]="true" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'transmitterModelNum'
                                        )
                                    " data-tx-key="label.gb.tranmsitter_model">
                                <!-- value="{{
                                viewData.transmitterModelNum]
                            }}" -->
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'btTxModel')" style="font-weight: bold" data-tx-key="label.gb.tranmsitter_model">{{
                                labels['label.gb.tranmsitter_model'
                               ]
                                }} : &nbsp;</span>{{ transmitterModelString }}
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-10 col-lg-12  gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox controlName="patAppSwVersion" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.pt_app_sw_ver']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'patAppSwVersion'
                                        )
                                    " data-tx-key="label.gb.pt_app_sw_ver">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'ptAppSwVer')" style="font-weight: bold" data-tx-key="label.gb.pt_app_sw_ver">{{
                                labels['label.gb.pt_app_sw_ver']
                                }}: </span> &nbsp;{{ viewData.appSWVersion }}
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-10 col-lg-12 gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox controlName="registrationDate" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.reg_date']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'registrationDate'
                                        )
                                    " data-tx-key="label.gb.reg_date">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'regDate')" style="font-weight: bold" data-tx-key="label.gb.reg_date">{{
                                labels['label.gb.reg_date']
                                }}: </span> &nbsp;{{ viewData.registrationDate }}
                            }
                        </div>
                    </div>
                    }
                    <p class="blueStyle" [class]="showTextLabel() ? 'mt-15':''">
                        @if (!bluetoothCapable) {
                        <span [id]="identifierService.labelId('enrollPatTx', 'transmitterSetupNote')" [innerHTML]="
                                labels['msg.gb.transmitter_setup_note']
                                    | safe : 'html'
                            " data-tx-key="msg.gb.transmitter_setup_note"></span>
                        }
                    </p>
                </div>
                <div class="col-xs-6 equal-textbox">
                    <h3 class="merlin-header">
                        <span [id]="identifierService.labelId('enrollPatientTransmitter', 'lastConnectionHeading')">{{ getLastConnectionHeadingDisplay() }}</span>
                    </h3>
                    <p class="blueStyle">
                        @if (enrollPatientTransmitter?.icmDeviceType && bluetoothCapable || this.ngqDeviceType) {
                        <span [id]="identifierService.labelId('enrollPatTx', 'txLastconnPromptIcm')" [innerHTML]="
                                labels[
                                    'msg.gb.transmitter_lastconn_prompt_icm'
                                ] | safe : 'html'
                            " data-tx-key="msg.gb.transmitter_lastconn_prompt_icm"></span>
                        }
                        @else if(this.lpDeviceType) {
                            <span [id]="identifierService.labelId('enrollPatTx', 'txLpLastconnPrompt')" [innerHTML]="
                                labels[
                                    'msg.gb.transmitter_lp_lastconn_prompt'
                                ] | safe : 'html'
                            " data-tx-key="msg.gb.transmitter_lp_lastconn_prompt"></span>
                        }
                        @else if (!bluetoothCapable) {
                        <span [id]="identifierService.labelId('enrollPatTx', 'txLastconnPrompt')" [innerHTML]="
                                labels['msg.gb.transmitter_lastconn_prompt']
                                    | safe : 'html'
                            " data-tx-key="msg.gb.transmitter_lastconn_prompt"></span>
                        }
                    </p>
                    @if (!bluetoothCapable) {
                    <div class="row">
                        <div class="col-xs-6 col-lg-12  gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="profileTransmitterSerialNum"
                                placeholder="{{
                                        labels['label.gb.trans_serial_no']
                                    }}:" value="{{
                                        getProfileTransmitterSerialNum(viewData)
                                    }}" label="{{
                                        labels['label.gb.trans_serial_no']
                                    }}" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'profileTransmitterSerialNum'
                                        )
                                    " data-tx-key="label.gb.trans_serial_no">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'lastConnSerialNo')" style="font-weight: bold" data-tx-key="label.gb.trans_serial_no">{{
                                labels['label.gb.trans_serial_no']
                                }}:&nbsp;
                            </span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'transSerialNoVal')">{{
                                getProfileTransmitterSerialNum(viewData)
                                }}</span>
                            }
                        </div>
                    </div>
                    }
                    @if (!bluetoothCapable) {
                    <div class="row">
                        <div class="col-xs-5 col-lg-12  gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="profileTransmitterModelNum"
                                placeholder="{{
                                        labels['label.gb.tranmsitter_model']
                                    }}:" value="{{
                                        profileTransmitterModelNum
                                    }}" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.tranmsitter_model']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'profileTransmitterModelNum'
                                        )
                                    " data-tx-key="label.gb.tranmsitter_model">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'lastConnTxModel')" style="font-weight: bold" data-tx-key="label.gb.tranmsitter_model">{{
                                labels['label.gb.tranmsitter_model'
                               ]
                                }}: &nbsp;
                            </span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'txModelNumVal')">{{ profileTransmitterModelNum }}</span>
                            }
                        </div>
                    </div>
                    }
                    @if (!bluetoothCapable) {
                    <div class="row">
                        <div class="col-xs-6 col-lg-12  gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="transmitterSoftwareVersion"
                                placeHolder="{{
                                        labels['label.gb.trans_sw_version']
                                    }}:" value="{{
                                        getTransmitterSoftwareVersion(viewData)
                                    }}" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.trans_sw_version']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'transmitterSoftwareVersion'
                                        )
                                    " data-tx-key="label.gb.trans_sw_version">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'transSwVersion')" style="font-weight: bold" data-tx-key="label.gb.trans_sw_version">{{
                                labels['label.gb.trans_sw_version']
                                }}: &nbsp;</span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'transSwVersionVal')">{{
                                getTransmitterSoftwareVersion(viewData)
                                }}</span>
                            }
                        </div>
                    </div>
                    }
                    <div class="row">
                        <div class="col-xs-5 col-lg-12 gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="lastConnectionType" [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " label="{{
                                        labels['label.gb.connection_type']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'lastConnectionType'
                                        )
                                    " data-tx-key="label.gb.connection_type">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'connectionType')" style="font-weight: bold" data-tx-key="label.gb.connection_type">{{
                                labels['label.gb.connection_type']
                                }}:&nbsp;
                            </span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'connectionTypeVal')"> {{getLastConnectionTypeDate(viewData)}}</span>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5 col-lg-12  gridActionPanel">
                            @if (showTextBox()) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="lastCommunicationDate" placeholder="{{
                                        labels['label.gb.last_comm_date']
                                    }}" [label]="
                                        labels['label.gb.last_comm_date']
                                    " [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'lastCommunicationDate'
                                        )
                                    " data-tx-key="label.gb.last_comm_date">
                            </merlin-textbox>
                            }
                            @if (showTextLabel()) {
                            <span style="font-weight: bold"><span [id]="identifierService.labelId('enrollPatTx', 'lastCommDate')" [innerHTML]="
                                            labels['label.gb.last_comm_date']
                                                | safe : 'html'
                                        " data-tx-key="label.gb.last_comm_date"></span>: &nbsp;</span>
                            <span [id]="identifierService.labelId('enrollPatientTransmitter', 'lastCommDateVal')">{{
                                getLastCommunicationDate(viewData)
                                }}</span>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5 col-lg-12  gridActionPanel">
                            @if (showTextBox() && !this.lpDeviceType) {
                            <merlin-textbox class="lstTrnsCommFields" controlName="lastDeviceCheckDate" [label]="
                                        labels['label.gb.last_device_check']
                                    " [groupName]="
                                        enrollPatientTransmitterFormGroup
                                    " placeholder="{{
                                        labels['label.gb.last_device_check']
                                    }}" [id]="
                                        identifierService.dropdownId(
                                            'enroll-patient-transmitter',
                                            'lastDeviceCheckDate'
                                        )
                                    " data-tx-key="label.gb.last_device_check">
                            </merlin-textbox>
                            }
                            @if (showTextLabel() && !this.lpDeviceType) {
                            <span style="font-weight: bold"><span [id]="identifierService.labelId('enrollPatTx', 'lastDeviceCheck')" [innerHTML]="
                                            labels[
                                                'label.gb.last_device_check'
                                            ] | safe : 'html'
                                        " data-tx-key="label.gb.last_device_check"></span>:&nbsp; </span><span [id]="identifierService.labelId('enrollPatientTransmitter', 'lastDeviceCheck')">{{
                                getLasDeviceCheckDate(viewData)
                                }}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </mat-card>

        <mat-card appearance="outlined" class="flat mt-10">
            <div class="row">
                <div class="col-xs-4">
                    <h3 [id]="identifierService.labelId('enrollPatTx', 'settingsHeader')" class="merlin-header text-align" data-tx-key="label.gb.settings">
                        {{ labels['label.gb.settings'] }}
                    </h3>
                </div>
                <div class="overRide-btn" [class.col-xs-2]="!bluetoothCapable" [class.col-xs-6]="bluetoothCapable">
                    @if (showOverrideBtn()) {
                    <button mat-raised-button class="btn-styl" color="accent" (click)="removeOverrides()"
                        [disabled]="bluetoothCapable && viewAndEnrollMode()" [id]="identifierService.dropdownId(
                                        'enroll-patient-transmitter',
                                        'removeOverridesBtn'
                                      )" data-tx-key="label.gb.remove_overrides">
                        {{ labels['label.gb.remove_overrides'] }}
                    </button>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-xs-4">
                    <section class="checkbox-section">
                        @if (!lpDeviceType){
                        <span>
                            <!-- RF Daily Device Check Enabled Checkbox  -->
                            <mat-checkbox color="primary" formControlName="rfDailyCheckEnabled"
                                (change)="onCheckboxChange($event)" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'rfDailyCheckEnabled'
                                )
                            ">
                                @if (isOverideOnEnroll('rfDailyCheckEnabled', 'deviceCheckFlg')) {
                                    <span>♦</span>
                                }
                                <span [id]="identifierService.labelId('enrollPatTx', 'performDailyDevChk')" [innerHTML]="labels['label.gb.perform_daily_dev_chk'] | safe : 'html'" data-tx-key="label.gb.perform_daily_dev_chk"></span>
                            </mat-checkbox>
                            <br />
                        </span>
                        }
                        @if (bluetoothCapable && enrollPatientTransmitter &&
                        enrollPatientTransmitter?.followUpCapable && showIdentifyKeyEpisodesSetting) {
                        <span style="display: flex;">
                            <mat-checkbox
                                color="primary"
                                formControlName="effectiveKeyEpisodeFlg"
                                (change)="onCheckboxChangeKeyEpi($event)"
                                [id]="identifierService.dropdownId('enroll-patient-transmitter','clinicKeyEpisodeFlg')">
                                @if (isOverideOnEnroll('effectiveKeyEpisodeFlg','clinicKeyEpisodeFlg')) { <span>♦</span> }
                                <span [id]="identifierService.labelId('enrollPatientTransmitter', 'identifyKe')" class="keyEpisode" data-tx-key="label.gb.identify_KE"></span>{{ labels['label.gb.identify_KE'] }}
                            </mat-checkbox>
                            <mat-icon class="p-l-10 questionMark" [mdePopoverTriggerFor]="keyEpisodePopover"></mat-icon>
                            <mde-popover #keyEpisodePopover="mdePopover"
                                        [mdePopoverOverlapTrigger]="false"
                                        mdePopoverPositionX="after"
                                        mdePopoverPositionY="above"
                                        mdePopoverArrowOffsetX="15">
                            <mat-card appearance="outlined" style="max-width:375px">
                                <mat-card-content>
                                <div [id]="identifierService.labelId('enrollPatTx', 'identifyKeInfo')" [innerHTML]="translatedHtmlLabels['label.gb.identify_KE_info'] | safe : 'html'"
                                    data-tx-key="label.gb.identify_KE_info"></div>
                                </mat-card-content>
                            </mat-card>
                            </mde-popover>
                            <a href="" (click)="openShowDevicesDialog(); $event.preventDefault(); $event.stopPropagation()" class="show-devices-link"
                                [id]="identifierService.labelId('reportSettings', 'showDevices')">{{labels['label.gb.show_ICM_devices']}}
                            </a>
                            <br />
                        </span>
                        }
                        @if (!(bluetoothCapable && (!enrollPatientTransmitter?.followUpCapable || enrollPatientTransmitter?.icmDeviceType))) {
                        <span class="checkbox-row">
                            <mat-checkbox color="primary"
                                formControlName="lockoutTransEnabled"
                                (change)="onCheckboxChange($event)"
                                [id]="identifierService.dropdownId('enroll-patient-transmitter','lockoutTransEnabled')"
                                data-tx-key="label.gb.lockout_unscheduled_transmissions">
                                @if (isOverideOnEnroll('lockoutTransEnabled','lockoutPatientInitTransFlg')) { <span>♦</span> }
                                {{ labels['label.gb.lockout_unscheduled_transmissions'] }}
                            </mat-checkbox>
                            @if (displayLockoutUnschedTooltip()) {
                            <mat-icon
                                [mdePopoverTriggerFor]="dataRatesPopover"
                                class="p-l-10 questionMark qestIcon"
                            ></mat-icon>
                            }
                            <mde-popover
                                #dataRatesPopover="mdePopover"
                                [mdePopoverOverlapTrigger]="false"
                                mdePopoverArrowOffsetX="15"
                                mdePopoverPositionX="after"
                                mdePopoverPositionY="above"
                            >
                                <mat-card appearance="outlined" style="max-width: 300px">
                                <mat-card-content data-tx-key="label.gb.lockout_lp_tooltip">
                                    <p [id]="identifierService.labelId('enrollPatTx', 'lockoutLpTooltip')">
                                    {{ labels['label.gb.lockout_lp_tooltip'] }}
                                    </p>
                                </mat-card-content>
                                </mat-card>
                            </mde-popover>
                        </span>
                        }
                    @if (!lpDeviceType){
                        @if(!bluetoothCapable) {
                            <span>
                                <mat-checkbox color="primary" formControlName="lockOutDeviceCheckEnabled"
                                    (change)="onCheckboxChange($event)" [id]="
                                    identifierService.dropdownId(
                                        'enroll-patient-transmitter',
                                        'lockOutDeviceCheckEnabled'
                                    )
                                ">
                                    @if (
                                    isOverideOnEnroll(
                                    'lockOutDeviceCheckEnabled',
                                    'lockoutPatientInitDcFlg'
                                    ) && enrollPatientTransmitter?.followUpCapable
                                    ) {
                                    <span>♦</span>
                                    }
                                    <span [id]="identifierService.labelId('enrollPatTx', 'lockoutDeviceChecks')" [innerHTML]="
                                        labels[
                                            'label.gb.lockout_device_checks'
                                        ] | safe : 'html'
                                    " data-tx-key="label.gb.lockout_device_checks"></span> </mat-checkbox><br />
                            </span>
                            <span>
                                <mat-checkbox color="primary" formControlName="enhancedDiagDataCollection"
                                    [id]="
                                    identifierService.dropdownId(
                                        'enroll-patient-transmitter',
                                        'enhancedDiagDataCollectionCheckbox'
                                    )
                                ">
                                    @if (
                                    isOverideOnEnroll(
                                    'enhancedDiagDataCollection',
                                    'enableMedFlg'
                                    )
                                    ) {
                                    <span>♦</span>
                                    }
                                    <span [id]="identifierService.labelId('enrollPatTx', 'collEnhncedDgnsticData')" [innerHTML]="
                                        labels[
                                            'label.gb.coll_enhncd_dgnstic_data'
                                        ] | safe : 'html'
                                    " data-tx-key="label.gb.coll_enhncd_dgnstic_data"></span> </mat-checkbox><br />
                                @if(enrollPatientTransmitter?.followUpCapable && enrollPatientTransmitter?.advisoryIndicationCode ===
                                ''){
                                <input type="hidden" formControlName="enhancedDiagDataCollection" value="true" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'enhancedDiagDataCollectionInput'
                                )
                                " />
                                }
                            </span>
                        }
                        }
                    </section>
                </div>
            </div>
            @if (!lpDeviceType){
            @if (!bluetoothCapable) {
            <div class="row">
                <!-- <div class="col-xs-1"></div> -->
                <div class="col-xs-8 volDrop">
                    @if (showTextBox()) {
                    <mat-form-field class="merlin-select merlin-row-styl mt-10" floatLabel="auto"
                        appearance="outline" [formGroup]="enrollPatientTransmitterFormGroup">
                        <mat-label [id]="identifierService.labelId('enrollPatTx', 'transVol')" data-tx-key="label.gb.trans_vol">{{ labels['label.gb.trans_vol'] }}
                        </mat-label>
                        <mat-select disableOptionCentering formControlName="transmitterVolumeCd" [id]="
                                    identifierService.dropdownId(
                                        'enroll-patient-transmitter',
                                        'transmitterVolumeCd'
                                    )
                                ">
                            @for (
                            eachObj of enrollPatientTransmitter
                            ?.dropdowns?.volumeCd
                            ; track
                            eachObj) {
                            <mat-option [id]="identifierService.listitemId('enrollPatTx', 'volumeCd_' + eachObj.codeId)" [value]="eachObj.codeId">
                                {{ labels['data.Code.Transmitter_Volume_Cd.Code_Desc.' + eachObj.code] }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    }
                    @if (showTextLabel()) {
                    <ng-container data-tx-key="label.gb.trans_vol">
                        {{ labels['label.gb.trans_vol'] }}: {{ showVolume(viewData.transmitterVolumeCd) }}
                    </ng-container>
                    }
                </div>
            </div>
            }
            }
        </mat-card>

        @if (unityDeviceType) {
        <mat-card appearance="outlined" class="flat mt-10">
            <h3 [id]="identifierService.labelId('enrollPatTx', 'recShpmntInfoHeader')" class="merlin-header" data-tx-key="label.gb.rec_shpmnt_info">
                  {{ labels['label.gb.rec_shpmnt_info'] }}
            </h3>
            <div class="row merlin-row-styl">
                <div class="col-xs-3 col-xs-3 col-lg-3">
                    @if (showTextBox()) {
                    <merlin-textbox controlName="shippedSerialNum" [groupName]="enrollPatientTransmitterFormGroup"
                        label="{{ labels['label.gb.trans_serial_no'] }}" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'shippedSerialNum'
                                )
                            " data-tx-key="label.gb.trans_serial_no">
                    </merlin-textbox>
                    }
                    @if (showTextLabel()) {
                    <span [id]="identifierService.labelId('enrollPatientTransmitter', 'shipSerialNo')" style="font-weight: bold" data-tx-key="label.gb.trans_serial_no">{{
                        labels['label.gb.trans_serial_no']
                        }}: </span>{{ viewData.shippedSerialNum || labels['label.gb.n_a'] }}
                    }
                </div>
                <div class="col-xs-3 col-xs-3 col-lg-3">
                    @if (showTextBox()) {
                    <merlin-textbox controlName="shippedModelNum" [groupName]="enrollPatientTransmitterFormGroup" label="{{
                                labels['label.gb.tranmsitter_model']
                            }}" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'shippedModelNum'
                                )
                            " data-tx-key="label.gb.tranmsitter_model">
                    </merlin-textbox>
                    }
                    @if (showTextLabel()) {
                    <span [id]="identifierService.labelId('enrollPatientTransmitter', 'shipTxModel')" style="font-weight: bold" data-tx-key="label.gb.tranmsitter_model">{{
                        labels['label.gb.tranmsitter_model']
                        }}: </span>{{ (viewData.shippedModelNum | translate) || labels['label.gb.n_a'] }}
                    }
                </div>
                <div class="col-xs-3 col-xs-3 col-lg-3">
                    @if (showTextBox()) {
                    <merlin-textbox controlName="orderedDate" [groupName]="enrollPatientTransmitterFormGroup" label="{{
                                translateKey('label.gb.ordered_date', '')
                            }}" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'orderedDate'
                                )
                            " data-tx-key="label.gb.ordered_date">
                    </merlin-textbox>
                    }
                    @if (showTextLabel()) {
                    <span [id]="identifierService.labelId('enrollPatTx', 'orderedDate')" style="font-weight: bold" [innerHTML]="
                                translateKey('label.gb.ordered_date', '') + ': '
                            ">
                    </span>{{ (viewData.orderedDate | date : dateFormat) || labels['label.gb.n_a'] }}
                    }
                </div>
                <div class="col-xs-3 col-xs-3 col-lg-3">
                    @if (showTextBox()) {
                    <merlin-textbox controlName="shippedDate" [groupName]="enrollPatientTransmitterFormGroup"
                        label="{{ labels['label.gb.shipped_date'] }}" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'shippedDate'
                                )
                            " data-tx-key="label.gb.shipped_date">
                    </merlin-textbox>
                    }
                    @if (showTextLabel()) {
                    <span [id]="identifierService.labelId('enrollPatientTransmitter', 'shippedDate')" style="font-weight: bold" data-tx-key="label.gb.shipped_date">{{ labels['label.gb.shipped_date'] }}: </span>{{ viewData.shippedDate || labels['label.gb.n_a'] }}
                    }
                </div>
            </div>
        </mat-card>
        }

        @if (!lpDeviceType){
        <mat-card appearance="outlined" class="flat mt-10">
            <h3 [id]="identifierService.labelId('enrollPatTx', 'complianceHeader')" class="merlin-header" data-tx-key="label.gb.compliance_hdr">
                {{ labels['label.gb.compliance_hdr'] }}
            </h3>
            @if (!complianceReport && (bluetoothCapable || deviceRfStatusFlag)) {
            <p [id]="identifierService.labelId('enrollPatTx', 'pa500Prompt')" data-tx-key="msg.pa500.prompt">
                {{ labels['msg.pa500.prompt'] }}
            </p>
            }
            @if (complianceReport && (bluetoothCapable || deviceRfStatusFlag)) {
            <p [id]="identifierService.labelId('enrollPatTx', 'pa501Prompt')" data-tx-key="msg.pa501.prompt">
                {{ labels['msg.pa501.prompt'] }}
            </p>
            }
            @if (showdeviceInductiveHeaderlabel()) {
            <p [id]="identifierService.labelId('enrollPatTx', 'pa502Prompt')" data-tx-key="msg.pa502.prompt">
                {{ labels['msg.pa502.prompt'] }}
            </p>
            }
            <div class="row">
                <div class="col-xs-6">
                    <section class="checkbox-section">
                        <mat-checkbox color="primary" formControlName="mistFlg" (change)="onMistFlagSelection($event)"
                            [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'mistFlg'
                                )
                            ">
                            @if (
                            showMistFlgOverride
                            ) {
                            <span id="mistFlgOverride">
                                ♦
                            </span>
                            }
                            <span [id]="identifierService.labelId('enrollPatTx', 'enableTxMonitoring')" [innerHTML]="
                                    labels['label.gb.enable_tx_monitoring']
                                        | safe : 'html'
                                " data-tx-key="label.gb.enable_tx_monitoring"></span> </mat-checkbox><br />
                        <div class="row">
                            <div style="margin-left: 25px" class="col-xs-8 mt-10">
                                @if (
                                showMistThresholdOverride
                                ) {
                                <span id="mistFlgOverride">
                                    ♦
                                </span>
                                }
                                <span [id]="identifierService.labelId('enrollPatTx', 'txMonitoringSetting')" data-tx-key="label.gb.tx_monitoring_setting">
                                    {{
                                    labels['label.gb.tx_monitoring_setting']
                                    }}:
                                </span>
                                <p class="blueSubStyle">
                                    <span [id]="identifierService.labelId('enrollPatTx', 'getText')" [innerHTML]="getText() | safe : 'html'"></span>
                                </p>
                            </div>
                            <div class="col-xs-2">
                                <div style="margin-top: 10px;">
                                    @if (showTextBox() && !devMedFlag) {
                                    <span class="mistField">
                                        @if (mistFlagSelection) {
                                        <mat-form-field appearance="outline" class="merlin-select days merlin-row-styl"
                                            [formGroup]="
                                        enrollPatientTransmitterFormGroup
                                    ">
                                            <mat-select disableOptionCentering formControlName="mistThreshold" [id]="
                                            identifierService.dropdownId(
                                                'enroll-patient-transmitter',
                                                'mistThreshold'
                                            )
                                        ">
                                                @for (
                                                eachObj of enrollPatientTransmitter?.mistThresholds
                                                ; track
                                                eachObj) {
                                                <mat-option [id]="identifierService.listitemId('enrollPatTx', 'mistThreshold_' + eachObj.value)" [value]="eachObj.value">
                                                    {{ eachObj.label }}
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        }<br />
                                    </span>
                                    }
                                    @if (devMedFlag) {
                                    <ng-container data-tx-key="label.gb.days">
                                        {{ viewData?.mistFlg ? viewData?.mistThreshold != 0 ?
                                        defaultMistThresholdForScheduleDaily : '' : '' }}
                                      {{ viewData?.mistFlg ?
                                        viewData?.mistThreshold != 0 || viewData?.mistThreshold != '' ? ( defaultMistThresholdForScheduleDaily ? (labels['label.gb.day_lc']) : (labels['label.gb.days'])) : '' : '' }}
                                    </ng-container>
                                    }
                                    @if (showTextLabel() && !devMedFlag) {
                                    <ng-container data-tx-key="label.gb.days">
                                        {{ viewData?.mistFlg ? viewData?.mistThreshold != 0 ? viewData.mistThreshold :
                                        '' : '' }}
                                      {{ viewData?.mistFlg ? viewData?.mistThreshold != 0 ||
                                        viewData?.mistThreshold != '' ? (viewData?.mistThreshold == 1 ? (labels['label.gb.day_lc']) : (labels['label.gb.days'])) : '' : '' }}
                                    </ng-container>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="col-xs-6 mt-15">
                    @if (!showTextLabel()) {
                    <span [id]="identifierService.labelId('enrollPatTx', 'snoozeThreshold')" data-tx-key="label.gb.snooze_threshold_until">
                        {{ labels['label.gb.snooze_threshold_until'] }}
                        :
                    </span>
                    <merlin-date-picker class="mr-10 w-100" [isForm]="true" [disabled]="mode === 'view'" [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'snoozeUntilDate'
                                )
                            " placeHolder="{{
                                datePlaceholder
                            }}" [groupName]="enrollPatientTransmitterFormGroup" [dateClassOverRide]="dateClass"
                        controlName="snoozeUntilDate" (changed)="snoozeUntilDateDPchanged($event)"
                        [date]="enrollPatientTransmitter?.snoozeUntilDate"
                        data-tx-key="label.gb.snooze_threshold_until">
                    </merlin-date-picker>
                    <br />
                    }
                    @if (showTextLabel()) {
                    <div [id]="identifierService.labelId('enrollPatTx', 'snoozeThresholdValue')" data-tx-key="label.gb.snooze_threshold_until">
                        {{ labels['label.gb.snooze_threshold_until'] }} : {{ viewData.snoozeUntilDate }}
                    </div>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <section class="checkbox-section">
                        <mat-checkbox color="primary" formControlName="nodcFlg" (change)="onNodcFlagSelection($event)"
                            [id]="
                                identifierService.dropdownId(
                                    'enroll-patient-transmitter',
                                    'nodcFlg'
                                )
                            ">
                            @if (
                            showNodcFlgOverride
                            ) {
                            <span id="nodcFlgOverride">
                                ♦
                            </span>
                            }
                            <span [id]="identifierService.labelId('enrollPatTx', 'enableDcMonitoring')" [innerHTML]="
                                    labels['label.gb.enable_dc_monitoring']
                                        | safe : 'html'
                                " data-tx-key="label.gb.enable_dc_monitoring"></span>
                        </mat-checkbox>
                        <div>
                            <div class="row">
                                <div style="margin-left: 25px;padding-right: 0;" class="col-xs-8 mt-10">
                                    @if (
                                    showNodcThresholdOverride
                                    ) {
                                    <span id="nodcFlgOverride">
                                        ♦
                                    </span>
                                    }
                                    <span [id]="identifierService.labelId('enrollPatTx', 'dcMonitoringSetting')" [innerHTML]="
                                    labels['label.gb.dc_monitoring_setting']
                                        | safe : 'html'
                                " data-tx-key="label.gb.dc_monitoring_setting"></span>:


                                    <p class="blueSubStyle">
                                        <span [id]="identifierService.labelId('enrollPatTx', 'txMonitoringNote2Icm')" [innerHTML]="
                                    labels[
                                        'label.gb.tx_monitoring_note2_ICM'
                                    ] | safe : 'html'
                                " data-tx-key="label.gb.tx_monitoring_note2_ICM"></span>
                                    </p>
                                </div>
                                <div class="col-xs-2">
                                    <div style="margin-top: 10px;">
                                        @if (showTextBox()) {
                                        <ng-container class="nodcField">
                                            @if (
                                            nodcFlagSelection &&
                                            mistFlagSelection &&
                                            directAlertSelection
                                            ) {
                                            <mat-form-field appearance="outline"
                                                class="merlin-select days merlin-row-styl" [formGroup]="
                                        enrollPatientTransmitterFormGroup
                                    ">
                                                <mat-select disableOptionCentering formControlName="nodcThreshold" [id]="
                                            identifierService.dropdownId(
                                                'enroll-patient-transmitter',
                                                'nodcThreshold'
                                            )
                                        ">
                                                    @for (
                                                    eachObj of enrollPatientTransmitter?.nodcThresholds
                                                    ; track
                                                    eachObj) {
                                                    <mat-option [id]="identifierService.listitemId('enrollPatTx', 'nodcThreshold_' + eachObj.value)" [value]="eachObj.value">
                                                        {{ eachObj.value }} {{ labels[eachObj.label] }}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                            }
                                        </ng-container>
                                        }
                                        @if (
                                        showTextLabel() &&
                                        viewData.nodcThreshold != null &&
                                        viewData.nodcThreshold != undefined
                                        ) {
                                        <ng-container data-tx-key="label.gb.days">
                                            {{ viewData?.nodcFlg ? viewData.nodcThreshold != 0 ? viewData.nodcThreshold : '' : '' }}
                                            {{ viewData?.nodcFlg ? viewData.nodcThreshold != 0 ? (viewData.nodcThreshold== '1' ? (labels['label.gb.day_lc']) : (labels['label.gb.days'])) : '' : '' }}
                                        </ng-container>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="col-xs-6">
                    @if (!showTextLabel()) {
                    <mat-form-field appearance="fill" class="compliance_notebox">
                        <textarea class="merlin-textarea" matInput style="min-height: 150px" maxlength="512"
                            formControlName="complianceNote" placeholder="{{
                                    labels['label.gb.compliance_note']
                                }}" [id]="
                                    identifierService.dropdownId(
                                        'enroll-patient-transmitter',
                                        'complianceNote'
                                    )
                                " data-tx-key="label.gb.compliance_note">
                        </textarea>
                    </mat-form-field>
                    }
                    @if (showTextLabel()) {
                    <div [id]="identifierService.labelId('enrollPatTx', 'complianceNote')" data-tx-key="label.gb.compliance_note">
                        {{ labels['label.gb.compliance_note'] }} :
                        <span [id]="identifierService.labelId('enrollPatTx', 'complianceNoteValue')" class="textWrap">
                            {{ viewData.complianceNote }}
                        </span>
                    </div>
                    }
                </div>
            </div>
        </mat-card>
        }
        @if (
        enrollPatientTransmitterFormGroup.get('transmitterModelNum')
        ?.invalid ||
        (enrollPatientTransmitterFormGroup.get('transmitterSerialNum')
        ?.invalid &&
        transmitterSerialRqdFlag)
        ) {
        <div [id]="identifierService.labelId('enrollPatTx', 'requiredField')" style="color: red" data-tx-key="label.gb.required_field">
            *{{ labels['label.gb.required_field'] }}
        </div>
        }
        <div style="color: blue">
            <span [id]="identifierService.labelId('enrollPatTx', 'overrideInstrText')" [innerHTML]="
                    labels['label.gb.override_instr_text'] | safe : 'html'
                " data-tx-key="label.gb.override_instr_text"></span>
        </div>
        @if (!profileMode()) {
        <div class="col-xs-4 col-xs-offset-8">
            <button mat-raised-button class="btn-styl" color="accent" (click)="back()" [id]="
                    identifierService.buttonId(
                        'enroll-patient-transmitter',
                        'enrollBackButton'
                    )
                    "
                data-tx-key="label.gb.back">
                {{ labels['label.gb.back'] }}</button>&nbsp;&nbsp;
            <button mat-raised-button class="btn-styl" color="accent" (click)="cancel()" [id]="
                    identifierService.buttonId(
                        'enroll-patient-transmitter',
                        'enrollCancelButton'
                    )
                    ">
                {{ labels['label.gb.button_cancel'] }}</button>&nbsp;&nbsp;
            <button mat-raised-button class="btn-styl" color="accent" (click)="onSaveAndCloseWithXssValidation()" [id]="
                    identifierService.buttonId(
                        'enroll-patient-transmitter',
                        'enrollSaveCloseButton'
                    )
                    ">
                {{ labels['label.gb.saveandclose'] }}</button>&nbsp;&nbsp;
            <button mat-raised-button class="btn-styl" color="primary" (click)="continue()" [id]="
                    identifierService.buttonId(
                        'enroll-patient-transmitter',
                        'enrollContinueButton'
                    )
                    ">
                {{ labels['label.gb.continue'] }}
            </button>
        </div>
        }
    </form>
</div>
